import { Helmet } from "react-helmet-async";
import { CLINIC } from "@/data/site";

const SITE_URL = process.env.REACT_APP_BACKEND_URL || "";

export const Seo = ({ title, description, path = "", image, jsonLd, type = "website" }) => {
  const fullTitle = title ? `${title} | ${CLINIC.name}` : `${CLINIC.name} | Thoughtful Dentistry`;
  const desc = description || "Thoughtful, ethical, precision dentistry in Greater Noida for Indian and international patients.";
  const url = `${SITE_URL}${path}`;
  const ogImage = image || "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=1200&q=80";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Dentist",
  name: CLINIC.name,
  description: "Premium ethical dental practice in Greater Noida serving Indian and international patients.",
  address: { "@type": "PostalAddress", addressLocality: "Greater Noida", addressRegion: "Uttar Pradesh", addressCountry: "IN" },
  telephone: CLINIC.phone,
  email: CLINIC.email,
  url: SITE_URL,
  medicalSpecialty: "Dentistry",
  priceRange: "$$",
};
